import React from "react";
import { Star, ArrowRight, Award } from "lucide-react";
import { useCMS, useSectionEnabled } from "../context/CMSContext";

export default function Reviews() {
  const enabled = useSectionEnabled("reviews");
  const { cms } = useCMS();
  if (!enabled) return null;
  const reviews = cms?.reviews || {};
  const testimonials = cms?.testimonials || [];

  return (
    <section className="bg-white relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-14 sm:py-16">
        <div className="flex flex-col md:flex-row items-start md:items-center gap-6 md:gap-8 mb-10">
          <div className="flex items-center gap-4">
            <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-full bg-gradient-to-br from-[#FFE6D6] to-[#FFD0B8] flex items-center justify-center">
              <Award className="w-8 h-8 sm:w-10 sm:h-10 text-[#B23B12]" />
            </div>
            <div>
              <div className="text-[#11151C]/60 text-xs sm:text-sm">Rated on {reviews.source}</div>
              <div className="flex items-center gap-2 mt-1 flex-wrap">
                <div className="flex">
                  {[1, 2, 3, 4, 5].map((i) => (
                    <Star key={i} className="w-4 h-4 fill-[#FF6B3D] text-[#FF6B3D]" />
                  ))}
                </div>
                <span className="lm-font font-extrabold text-[#11151C] text-xl sm:text-2xl">{reviews.rating}</span>
                <span className="text-[#11151C]/60 text-xs sm:text-sm">based on {reviews.count} reviews</span>
              </div>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-5">
          {testimonials.map((t) => (
            <div key={t.author} className="lm-card p-6">
              <div className="flex gap-1 mb-3">
                {[1, 2, 3, 4, 5].map((i) => (
                  <Star key={i} className="w-4 h-4 fill-[#FF6B3D] text-[#FF6B3D]" />
                ))}
              </div>
              <h4 className="lm-font font-bold text-[#11151C] text-base sm:text-lg mb-2">{t.title}</h4>
              <p className="text-[#11151C]/70 text-sm leading-relaxed">{t.body}</p>
              <div className="mt-5 pt-4 border-t border-[#11151C]/5 flex items-center gap-3">
                <div className="w-9 h-9 rounded-full bg-gradient-to-br from-[#FFE6D6] to-[#FFD0B8] flex items-center justify-center font-bold text-[#B23B12] text-sm">
                  {t.author?.charAt(0) || "U"}
                </div>
                <div>
                  <div className="text-[#11151C] font-semibold text-sm">{t.author}</div>
                  <div className="text-[#11151C]/50 text-xs">{t.date}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 flex justify-center">
          <a href={reviews.sourceUrl || "#reviews"} className="inline-flex items-center gap-2 text-[#11151C] font-semibold hover:text-[#FF6B3D] transition-colors">
            Read all {reviews.count} reviews on {reviews.source}
            <ArrowRight className="w-4 h-4" />
          </a>
        </div>
      </div>
    </section>
  );
}
